import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { template } from 'utils/TemplateReplacement';
import './style.css';

// eslint-disable-next-line react/prefer-stateless-function
class RenameGroupNoticeMessageItem extends Component {
  render() {
    const { message } = this.props;
    return (
      <div style={{ textAlign: 'center' }}>
        <div className="message-notice">
          {template(message.messageMeta.noticeMessageTemplate, {
            changedUsername: (
              <Link
                key={`changedUserNotice-${message.id}-${message.messageMeta.changedUserId}`}
                to={`/users/profile/${message.messageMeta.changedUserId}`}
              >
                {message.messageMeta.changedUsername}
              </Link>
            ),
            newGroupName: message.messageMeta.newGroupName
          })}
        </div>
      </div>
    );
  }
}

RenameGroupNoticeMessageItem.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.number.isRequired,
    messageMeta: PropTypes.shape({
      noticeMessageTemplate: PropTypes.string.isRequired,
      changedUsername: PropTypes.string.isRequired,
      newGroupName: PropTypes.string.isRequired,
      changedUserId: PropTypes.number.isRequired
    }).isRequired
  }).isRequired
};

export default RenameGroupNoticeMessageItem;



// WEBPACK FOOTER //
// ./src/components/Messenger/content/RoomViewBlock/RoomMainBlock/_messages/RenameGroupNoticeMessageItem.js